import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';

import { useSelector } from 'store';
import { removeMessage } from 'features/message/redux/action';

export const MessageSender = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { messages } = useSelector(state => state.message);

  useEffect(() => {
    messages?.forEach(({ timestamp, content, type }) => {
      if (typeof content !== 'object') {
        enqueueSnackbar(content, { variant: type });
      }

      dispatch(removeMessage(timestamp));
    });
  }, [messages, enqueueSnackbar, dispatch]);

  return null;
};
